// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PosController from "./pos_controller"
application.register("pos", PosController)

import ClockController from "./clock_controller"
application.register("clock", ClockController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import RequestOtpController from "./request_otp_controller"
application.register("request-otp", RequestOtpController)

import ProductSuppliersController from "./product_suppliers_controller"
application.register("product-suppliers", ProductSuppliersController)

import ProductPickerController from "./product_picker_controller"
application.register("product-picker", ProductPickerController)
